import { ApiKeyOrGetter } from "./GeneralService";
import { GeneralService } from "./GeneralService";
import { Config } from "../model_gen/config";

export class IntentService {
    public static getIntentGroups(
        offset: number,
        limit: number,
        loadingHandler: ((val: boolean) => void) | undefined, 
        apiKey: ApiKeyOrGetter
    ) {
        return GeneralService.get(
            `/intent/groups/${offset}/${limit}`,
            loadingHandler,
            JSON,
            GeneralService.PROD_ENDPOINT,
            apiKey
        );
    }

    public static getIntentGroup(
        intentGroupId: number,
        includeDetails: boolean,
        loadingHandler: ((val: boolean) => void) | undefined,
        apiKey: ApiKeyOrGetter
    ) {
        return GeneralService.get(
            `/intent/groups/${intentGroupId}/${includeDetails}`,
            loadingHandler,
            JSON,
            GeneralService.PROD_ENDPOINT,
            apiKey
        );
    }

    public static getIntentGroupByApplicationAndIntent(
        applicationId: number,
        applicationActionId: number,
        loadingHandler: ((val: boolean) => void) | undefined,
        apiKey: ApiKeyOrGetter
    ) {
        return GeneralService.get(`/intent/groups/application/${applicationId}/intent/${applicationActionId}`, loadingHandler, JSON, GeneralService.PROD_ENDPOINT, apiKey);
    }

    public static getIntentsByIntentGroup(
        intentGroupId: number,
        offset: number = 0,
        limit: number = 10,
        loadingHandler: ((val: boolean) => void) | undefined,
        apiKey: ApiKeyOrGetter
    ) {
        return GeneralService.get(
            `/intent/groups/${intentGroupId}/${offset}/${limit}`,
            loadingHandler,
            JSON,
            GeneralService.PROD_ENDPOINT,
            apiKey
        );
    }

    public static setIntentGroupConfig(
        intentGroupId: number,
        config: Partial<Config>,
        loadingHandler: ((val: boolean) => void) | undefined,
        apiKey: ApiKeyOrGetter
    ) {
        return GeneralService.post(
            `/intent/groups/${intentGroupId}/config`,
            JSON.stringify(config),
            loadingHandler,
            JSON,
            GeneralService.PROD_ENDPOINT,
            apiKey
        );
    }

    public static resetIntentGroupConfig(
        intentGroupId: number,
        loadingHandler: ((val: boolean) => void) | undefined,
        apiKey: ApiKeyOrGetter
    ) {
        return GeneralService.delete(
            `/intent/groups/${intentGroupId}/config`,
            "",
            loadingHandler,
            JSON,
            GeneralService.PROD_ENDPOINT,
            apiKey
        );
    }

    public static getIntentGroupRequests(
        intentGroupId: number,
        startDate: number,
        endDate: number,
        offset: number,
        limit: number,
        loadingHandler: ((val: boolean) => void) | undefined,
        apiKey: ApiKeyOrGetter
    ) {
        return GeneralService.get(
            `/intent/groups/${intentGroupId}/requests/${startDate}/${endDate}/${offset}/${limit}`,
            loadingHandler,
            JSON,
            GeneralService.PROD_ENDPOINT,
            apiKey
        );
    }
}
  
  